import { types } from "../types/typesCentroCosto";

const initialState = {
  centroscostos: [],
  activeCentroCosto: null,
  loading: false,
};
export const centrocostoReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.centroscostosLoaded:
      return { ...state, centroscostos: action.payload };
    case types.centrocostoAdded:
      return {
        ...state,
        centroscostos: [...state.centroscostos, action.payload],
      };
    case types.centrocostoSetActive:
      return {
        ...state,
        activeCentroCosto: action.payload,
      };
    case types.centrocostoClearActive:
      return {
        ...state,
        activeCentroCosto: null,
      };
    case types.centrocostoUpdated:
      return {
        ...state,
        centroscostos: state.centroscostos.map((e) =>
          e.id === action.payload.id ? action.payload : e,
        ),
      };
    case types.centrocostoDeleted:
      return {
        ...state,
        centroscostos: state.centroscostos.filter(
          (e) => e.id !== action.payload.id,
        ),
        activeCentroCosto: null,
      };
    case types.centrocostoLoading:
      return {
        ...state,
        loading: action.payload,
      };
    case types.centrocostoLogout:
      return { ...initialState };
    default:
      return state;
  }
};
